import { IEditCustomerFormProps } from "../../CustomerDetails/interface";
import AddCustomerForms from "../AddCustomerForms";

const EditCustomerInfoForm: React.FC<IEditCustomerFormProps> = () => {
  return (
    <div className="mb-20">
      <AddCustomerForms addressLayout="MULTI" forUpdate={true} layoutFor="CUSTOMER" />
    </div>
  );
};
export default EditCustomerInfoForm;
